<ng-container *transloco="let t">

<div class="toggle" [ngClass]="className">
    @for (option of options; track option.value) {
    <button
      class="toggle-btn"
      [class.active]="isActive(option.value)"
      [disabled]="option.disabled"
      (click)="select(option.value)"
    >
    {{ t(option.label) }}
    </button>
    }
</div>
</ng-container>